import { defaultTheme } from '@3plearning/react-components';

export default {
  ...defaultTheme?.palette,
  primary: {
    light: '#eaf9f9',
    main: '#415667',
    dark: '#415667',
    text: '#ffffff'
  },
  secondary: {
    light: '#7fa7c2',
    main: '#7fa7c2',
    dark: '#3b4e5e',
    text: '#000'
  },
  error: {
    light: '#bf2c30',
    main: '#b01e22',
    dark: '#6f1315',
    text: '#fff'
  },
  warning: {
    light: '#cb4b1a',
    main: '#c63a04',
    dark: '#942c04',
    text: '#fff'
  }
};



// WEBPACK FOOTER //
// ./themes/course-assign-theme/palette.js